var _circle, _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSegmentLibrary(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.4134,
    cy: 16.4134,
    r: 9.0013,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4134 1.82715C16.4134 1.27486 16.8616 0.823806 17.4128 0.859213C20.144 1.03467 22.7873 1.92688 25.0727 3.45391C27.6358 5.16655 29.6335 7.60079 30.8132 10.4488C31.9929 13.2968 32.3016 16.4307 31.7002 19.4541C31.0988 22.4776 29.6143 25.2548 27.4346 27.4346C25.2548 29.6143 22.4776 31.0988 19.4541 31.7002C16.4307 32.3016 13.2968 31.9929 10.4488 30.8132C7.60079 29.6335 5.16655 27.6358 3.45391 25.0727C1.92688 22.7873 1.03467 20.144 0.859213 17.4128C0.823806 16.8616 1.27486 16.4134 1.82715 16.4134H7.59771C8.15 16.4134 8.59112 16.8629 8.66159 17.4107C8.81499 18.603 9.24204 19.7486 9.91489 20.7556C10.7737 22.0409 11.9943 23.0426 13.4225 23.6342C14.8506 24.2257 16.4221 24.3805 17.9382 24.0789C19.4543 23.7774 20.8469 23.033 21.9399 21.9399C23.033 20.8469 23.7774 19.4543 24.0789 17.9382C24.3805 16.4221 24.2257 14.8506 23.6342 13.4225C23.0426 11.9943 22.0409 10.7737 20.7556 9.91489C19.7486 9.24204 18.603 8.81499 17.4107 8.66159C16.8629 8.59112 16.4134 8.14999 16.4134 7.59771V1.82715Z",
    fill: "#E1E1E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5863 1C15.5863 0.447716 15.1381 -0.00334148 14.5869 0.0320684C12.882 0.141608 11.2043 0.530894 9.62165 1.18643C7.73064 1.96972 6.01243 3.11779 4.56511 4.56511C3.11779 6.01243 1.96972 7.73064 1.18643 9.62166C0.530893 11.2043 0.141607 12.882 0.0320682 14.5869C-0.00334156 15.1381 0.447715 15.5863 1 15.5863L7.96275 15.5863C8.51503 15.5863 8.95503 15.136 9.03809 14.59C9.11828 14.063 9.26198 13.5463 9.46693 13.0515C9.79979 12.2479 10.2877 11.5178 10.9027 10.9027C11.5178 10.2877 12.2479 9.79979 13.0515 9.46693C13.5463 9.26198 14.063 9.11828 14.59 9.03809C15.136 8.95503 15.5863 8.51503 15.5863 7.96275V1Z",
    fill: "#9B5AF8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_821_22559)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.827148,
    width: 7.79528,
    height: 7.79528,
    rx: 3.89764,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.84647 5.0496H4.22245V6.67362C4.22245 6.85226 4.07629 6.99842 3.89765 6.99842C3.71901 6.99842 3.57284 6.85226 3.57284 6.67362V5.0496H1.94883C1.77018 5.0496 1.62402 4.90344 1.62402 4.7248C1.62402 4.54615 1.77018 4.39999 1.94883 4.39999H3.57284V2.77598C3.57284 2.59733 3.71901 2.45117 3.89765 2.45117C4.07629 2.45117 4.22245 2.59733 4.22245 2.77598V4.39999H5.84647C6.02511 4.39999 6.17127 4.54615 6.17127 4.7248C6.17127 4.90344 6.02511 5.0496 5.84647 5.0496Z",
    fill: "#9B5AF8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_821_22559"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.827148,
    width: 7.79528,
    height: 7.79528,
    rx: 3.89764,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSegmentLibrary);
export default __webpack_public_path__ + "static/media/SegmentLibrary.8b53ca46dd3bf2947666cb400c57c6ac.svg";
export { ForwardRef as ReactComponent };